export enum VehicleType {
  Undefined = 0,
  Automatic = 1,
  LogHandler = 2,
  Truck = 3,
  CoilForklift = 4,
  BulkHandler = 5,
  PackageHandler = 6,
}
